export enum Locale {
  ENGLISH = "en",
  KOREAN = "ko",
  SPANISH = "es",
  FRENCH = "fr",
  RUSSIAN = "ru",
  CHINESE = "zh",
  ARABIC = "ar",
}
